export interface PrescriptionSignatureLineItem {
  category: number
  checkFlag: boolean
  userId: number | null
  userName: string
}

export const PRESCRIPTION_SIGNATURE_LINE_OPTIONS = [
  { category: 1, label: '调配' },
  { category: 2, label: '审核' },
  { category: 3, label: '核对/发药' },
  { category: 4, label: '收费员' },
] as const

const PRESCRIPTION_SIGNATURE_LINE_MAP = new Map(
  PRESCRIPTION_SIGNATURE_LINE_OPTIONS.map(item => [item.category, item.label])
)

export const createDefaultPrescriptionSignatureLine =
  (): PrescriptionSignatureLineItem[] => {
    return PRESCRIPTION_SIGNATURE_LINE_OPTIONS.map(item => ({
      category: item.category,
      checkFlag: false,
      userId: null,
      userName: '',
    }))
  }

export const normalizePrescriptionSignatureLine = (
  signatureLine: any[] | null = []
): PrescriptionSignatureLineItem[] => {
  const lineMap = new Map<number, any>()

  const signatureLineList = Array.isArray(signatureLine) ? signatureLine : []

  signatureLineList.forEach(item => {
    const category = Number(item?.category)
    if (PRESCRIPTION_SIGNATURE_LINE_MAP.has(category)) {
      lineMap.set(category, item)
    }
  })

  return PRESCRIPTION_SIGNATURE_LINE_OPTIONS.map(item => {
    const current = lineMap.get(item.category)
    return {
      category: item.category,
      checkFlag: Boolean(current?.checkFlag),
      userId:
        current?.userId === null || current?.userId === undefined
          ? null
          : Number(current.userId),
      userName: String(current?.userName || '').trim(),
    }
  })
}

export const getPrescriptionSignatureLineLabel = (category: number) => {
  return PRESCRIPTION_SIGNATURE_LINE_MAP.get(Number(category)) || ''
}

export const getEnabledPrescriptionSignatureLines = (
  signatureLine: any[] | null = []
) => {
  return normalizePrescriptionSignatureLine(signatureLine)
    .filter(item => item.checkFlag)
    .map(item => ({
      ...item,
      label: getPrescriptionSignatureLineLabel(item.category),
    }))
}
